import * as fromAuthZ from '../actions/authz.action';
import {
    AUTHZ_INIT,
    AUTHZ_INIT_ERROR,
    AUTHZ_INIT_SUCCESS,
    AUTHZ_INIT_PROCESS_SUCCESS,
    AUTHZ_SELECT_STRUCTURE,
    AUTHZ_STRUCTURES_LIST,
    AUTHZ_STRUCTURES_LIST_ERROR,
    AUTHZ_STRUCTURES_LIST_SUCCESS
} from '../actions/authz.action';
import {LoadingGroup} from '../models/loading.model';
export interface StructureModel {
  code: string;
  libelleAffichage: string;
}

export interface AuthZState {
    autorizedStructuresList: Array<StructureModel>;
    autorizedStructuresListLoading: LoadingGroup;
    autorizedStructureSelected: StructureModel | null;
    autorizedModules: Array<string>;
    autorizedModulesLoading: LoadingGroup;
    requestingModule: string | null;
    hasAccessToRequestingModule: boolean;
    traitementsListForRequestingModule: Array<string>;
    perimetresListForUser: Array<string>;
    rolesListForRequestingModule: Array<{ codeStructure: string, traitements: Array<string> }>;
}

export const initialAuthZState = {
    autorizedStructuresList: [],
    autorizedStructuresListLoading: new LoadingGroup(),
    autorizedStructureSelected: null,
    autorizedModules: [],
    autorizedModulesLoading: new LoadingGroup(),
    requestingModule: null,
    hasAccessToRequestingModule: false,
    traitementsListForRequestingModule: [],
    perimetresListForUser: [],
    rolesListForRequestingModule: []
};

export function reducer(
    state: AuthZState = initialAuthZState,
    action: fromAuthZ.AuthZAction
) {
    switch (action.type) {

        case AUTHZ_STRUCTURES_LIST: {
            return {
                ...state,
                autorizedStructuresListLoading: state.autorizedStructuresListLoading.start()
            };
        }

        case AUTHZ_STRUCTURES_LIST_SUCCESS: {
            return {
                ...state,
                autorizedStructuresList: action.autorizedStructuresList,
                autorizedStructuresListLoading: state.autorizedStructuresListLoading.success()
            };
        }

        case AUTHZ_STRUCTURES_LIST_ERROR: {
            return {
                ...state,
                autorizedStructuresListLoading: state.autorizedStructuresListLoading.fail(action.payload)
            };
        }

      case AUTHZ_SELECT_STRUCTURE: {
        // Vérifie si la structure sélectionnée est bien dans la liste des structures autorisées, sinon aucune sélection
        const structureTrouvee = state.autorizedStructuresList.find(
          (s: StructureModel) => s.code === action.structure?.code
        ) || null;

        return {
          ...state,
          autorizedStructureSelected: structureTrouvee
        };
      }

        case AUTHZ_INIT: {
            return {
                ...state,
                autorizedModulesLoading: state.autorizedModulesLoading.start(),
            };
        }

        case AUTHZ_INIT_PROCESS_SUCCESS: {
          return {
            ...state,
            autorizedModules: action.autorizedModules,
            requestingModule: action.requestingModule,
            traitementsListForRequestingModule: action.traitementsListForRequestingModule,
            perimetresListForUser: action.perimetresListForUser,
            hasAccessToRequestingModule: action.hasAccessToRequestingModule,
          };
      }
        case AUTHZ_INIT_SUCCESS: {
            return {
                ...state,
                autorizedModulesLoading: state.autorizedModulesLoading.success()
            };
        }

        case AUTHZ_INIT_ERROR: {
            return {
                ...state,
                autorizedModulesLoading: state.autorizedModulesLoading.fail(action.payload)
            };
        }

        default:
            return state;
    }

}
